import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Sidebar from "./components/sidebar";
import Topbar from "./components/topbar";
import Dashboard from "./pages/Dashboard";
import ImageUploader from "./pages/ImageUploader";
import ScannedHouses from "./pages/ScannedHouses";
import DoubleSlider from "./pages/DoubleSlider";
import Settings from "./pages/Settings";
import Announcements from "./pages/AdminAnnouncements";
import Feedback from "./pages/Feedback";
import UserPage from "./pages/UsersPage";
import VerifyPage from "./pages/VerifyPage"; // ✅ NEW: import VerifyPage

// ✅ Simple mock authentication check
const isAuthenticated = () => {
  return Boolean(localStorage.getItem("user"));
};

// ✅ Wrapper component to protect routes
function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  const location = useLocation();

  // ✅ Authentication page check
  const isAuthPage =
    location.pathname === "/" || location.pathname.startsWith("/auth");

  // ✅ Define titles per route
  const routeTitles = {
    "/dashboard": "Dashboard",
    "/upload": "Upload Image",
    "/scanned-houses": "Scanned Houses",
    "/announcements": "Announcements",
    "/feedback": "Feedback",
    "/settings": "Settings",
    "/users": "Users",
    "/verify": "Verify Account", // ✅ Added Verify page title
  };

  const currentTitle = routeTitles[location.pathname] || "";

  return (
    <div className="app-container" style={{ display: "flex", height: "100vh" }}>
      {!isAuthPage && <Sidebar />}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {!isAuthPage && <Topbar title={currentTitle} />}
        <main style={{ flex: 1 }}>
          <Routes>
            {/* ✅ Public Routes */}
            <Route path="/" element={<DoubleSlider />} />
            <Route path="/auth" element={<DoubleSlider />} />

            {/* ✅ Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <ImageUploader />
                </ProtectedRoute>
              }
            />
            <Route
              path="/scanned-houses"
              element={
                <ProtectedRoute>
                  <ScannedHouses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/announcements"
              element={
                <ProtectedRoute>
                  <Announcements />
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback"
              element={
                <ProtectedRoute>
                  <Feedback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <UserPage />
                </ProtectedRoute>
              }
            />
            {/* ✅ NEW Verify Page */}
            <Route
              path="/verify"
              element={
                <ProtectedRoute>
                  <VerifyPage />
                </ProtectedRoute>
              }
            />

            {/* ✅ 404 Fallback */}
            <Route path="*" element={<h2>404 - Page Not Found</h2>} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default App;
